module.exports = __webpack_public_path__ + "img/SKWINKELNetActieCampagnematerialenE2A637.3379f1f4.png";